/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import { vaccineVaccinationsService } from '../../../_services/vaccine-vaccinations.service';
import { useParams, Link } from 'react-router-dom';
import { alertActions } from '../../../_actions/alert.actions';
import { history } from '../../../_helpers/history';
import { Form, Jumbotron, Spinner } from 'react-bootstrap';
import moment from 'moment';

export default function VaccinationDetails(props) {
  const [details, setDetails] = useState([]);
  const params = useParams();

  const vaccineEligibility = {
    V01: "Not VFC eligible",
    V02: "VFC eligible-Medicaid/Medicaid Managed Care",
    V03: "VFC eligible-Uninsured",
    V04: "VFC eligible-American Indian/Alaskan Native",
    V05: "VFC eligible-Federally Qualified Health Center Patient (under-insured)",
    V06: "VFC eligible-State specific eligibility (e.g. S-CHIP plan)",
    V07: "VFC eligibility-Local-specific eligibility",
    V08: "Not VFC eligible-Under-insured",
  }

  const bodySite = {
    BE: "Bilateral Ears",
    BN: "Bilateral Nares",
    BU: "Buttock",
    CT: "Chest Tube",
    LA: "Left Arm",
    LAC: "Left Anterior Chest",
    LACF: "Left Antecubital Fossa",
    LD: "Left Deltoid",
    LE: "Left Ear",
    LEJ: "Left External Jugular",
    LF: "Left Foot",
    LG: "Left Gluteus Medius",
    LH: "Left Hand",
    LIJ: "Left Internal Jugular",
    LLAQ: "Left Lower Abd Quadrant",
    LLFA: "Left Lower Forearm",
    LMFA: "Left Mid Forearm",
    LN: "Left Naris",
    LPC: "Left Posterior Chest",
    LSC: "Left Subclavian",
    LT: "Left Thigh",
    LUA: "Left Upper Arm",
    LUAQ: "Left Upper Abd Quadrant",
    LUFA: "Left Upper Forearm",
    LVG: "Left Ventragluteal",
    LVL: "Left Vastus Lateralis",
    NB: "Nebulized",
    OD: "Right Eye",
    OS: "Left Eye",
    OU: "Bilateral Eyes",
    PA: "Perianal",
    PERIN: "Perineal",
    RA: "Right Arm",
    RAC: "Right Anterior Chest",
    RACF: "Right Antecubital Fossa",
    RD: "Right Deltoid",
    RE: "Right Ear",
    REJ: "Right External Jugular",
    RF: "Right Foot",
    RG: "Right Gluteus Medius",
    RH: "Right Hand",
    RIJ: "Right Internal Jugular",
    RLAQ: "Rt Lower Abd Quadrant",
    RLFA: "Right Lower Forearm",
    RMFA: "Right Mid Forearm",
    RN: "Right Naris",
    RPC: "Right Posterior Chest",
    RSC: "Right Subclavian",
    RT: "Right Thigh",
    RUA: "Right Upper Arm",
    RUAQ: "Right Upper Abd Quadrant",
    RUFA: "Right Upper Forearm",
    RVG: "Right Ventragluteal",
    RVL: "Right Vastus Lateralis",
  };

  function getVaccinationDetails(id) {
    vaccineVaccinationsService.getDetails(id)
      .then(data => {
        setDetails(data);
      }).catch(() => {
        props.dispatch(alertActions.error('Could not view vaccination at this time. Please try again.'));
        history.push(`/vaccine/cair`);
      });
  }

  useEffect(() => {
    getVaccinationDetails(params.id);
  }, [])

  return <div className="mt-4">
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
        <li className="breadcrumb-item"><Link to="/vaccine/cair">CAIR</Link></li>
        <li className="breadcrumb-item active" aria-current="page">View</li>
      </ol>
    </nav>
    <div className="card axs-shadow">
      <div className="card-header">
        <h5>View CAIR</h5>
      </div>
      <div className="card-body">
        <div className="row">
          <div className="col">
            {details.length === 0 ?
              <Jumbotron className="text-center bg-white">
                <div className="row">
                  <div className="col-auto offset-5">
                    <Spinner animation="border" />
                  </div>
                  <div className="col-auto">
                    <h3><b>Loading...</b></h3>
                  </div>
                </div>
              </Jumbotron>
              :
              <Form>
                <Form.Group>
                  <div className="row">
                    <div className="col"><strong>Last Name:</strong> {details.lastName}</div>
                    <div className="col"><strong>First Name:</strong> {details.firstName}</div>
                    <div className="col"><strong>Date of Birth:</strong> {details.dateOfBirth && moment(details.dateOfBirth).format("L")}</div>
                    <div className="col"><strong>Mother's First Name:</strong> {details.mothersFirstName}</div>
                  </div>
                </Form.Group>

                <hr />

                <Form.Group>
                  <div className="row">
                    <div className="col-3"><strong>Patient's Zip Code:</strong> {details.zipCode}</div>
                    <div className="col-3"><strong>Patient's City:</strong> {details.city}</div>
                  </div>
                </Form.Group>

                <hr />

                <Form.Group>
                  <div className="row">
                    <div className="col"><strong>Race:</strong> {details.race}</div>
                    <div className="col"><strong>Gender:</strong> {details.gender}</div>
                    <div className="col"><strong>Ethnicity:</strong> {details.ethnicity}</div>
                    <div className="col"><strong>Occupation:</strong> {details.occupation}</div>
                  </div>
                </Form.Group>

                <hr />

                <Form.Group>
                  <div className="row">
                    <div className="col"><strong>Vaccine Eligibility:</strong> {vaccineEligibility[details.vaccineEligibility]}</div>
                    <div className="col"><strong>Vaccine:</strong> {details.vaccine}</div>
                    <div className="col"><strong>Lot Number:</strong> {details.lotNumber}</div>
                    <div className="col"><strong>Body Site:</strong> {bodySite[details.bodySite]}</div>
                  </div>
                </Form.Group>

                <hr />

                <Form.Group>
                  <div className="row">
                    <div className="col-3"><strong>Vaccinator Full Name:</strong> {details.vaccinatorFullName}</div>
                    <div className="col-3"><strong>Title:</strong> {details.title}</div>
                  </div>
                </Form.Group>
              </Form>
            }

            <hr />

            <div className="row p-2">
              <div className="col-2"><Link to="/vaccine/cair" className="btn btn-block btn-outline-primary">Back</Link></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
